export default __webpack_public_path__ + "static/media/ic_united_arab_emirates.658b0630.svg";